import axios from 'axios';
import imagesLoaded from 'imagesloaded';
import * as Utils from './utils';

export function init() {
    const btns = document.querySelectorAll('.js-load-more'),
        limit = 4;

    // When clicking load more button
    btns.forEach(btn => {
        btn.addEventListener('click', e => {
            e.preventDefault();

            const list = btn.closest('.js-news-events-container').querySelector('ul'),
                entryType = btn.dataset.entrytype,
                totalEntries = btn.dataset.total;

            // Count number of items already in list
            let itemCount = list.querySelectorAll('li').length;

            // Show loading icon
            btn.classList.add('loading');
            
            // Run request for more items 
            axios
                .get(`/news-events/get-items?offset=${itemCount}&type=${entryType}&limit=${limit}`, {
                    headers: { "X-Requested-With": "XMLHttpRequest" }
                })
                .then(function(response) {
                    // Append items to list
                    let newItemsHTML = Utils.stringToHTML(response.data);
                    
                    // Loop over returned list items and insert to DOM
                    newItemsHTML.querySelectorAll('li').forEach(item => {
                        list.appendChild(item);
                    })
                    
                    // Once images have been loaded
                    imagesLoaded(list, () => {
                        // Run 'watch' transition functions
                        Utils.animateInViewEls('.js-watch', 'in-view', 0.1);

                        // Hide loading icon
                        btn.classList.remove('loading');
                        
                        // Check if we need the loading button still?
                        if (list.querySelectorAll('li').length >= parseInt(totalEntries)) {
                            btn.classList.add('hide');
                        }
                    });
                })
                .catch(function(error) {
                    console.error(error);
                });
        })
    });
}